import { Controller, useForm } from 'react-hook-form'
import { Chip, makeStyles } from '@material-ui/core'
import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import SydButton from '../../../../commonDesign/Button'
import SydLabel, { hookFormErrorAdapter } from '../../../../commonDesign/SydLabel'
import SydInput from '../../../../commonDesign/SydInput'
import SaveCancelFooter from '../../shared/SaveCancelFooter'
import { useModifyClientTag } from '../../../../../api/dataMaintenance'
import Loading from '../../../../molecules/Loading'
const useStyles = makeStyles((theme) => ({
  detailsHeader: {
    display: 'flex',
    gap: '1rem',
    alignItems: 'center'
  },
  detailRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '2rem'
  },
  detailCol: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }
}))

export const TagDetailsTab = ({ groupTypeId, tagDetailData, detailsLoading }) => {
  const { mutateAsync: modifyClientTag, isLoading } = useModifyClientTag()
  const [editing, setEditing] = useState(false)
  const classes = useStyles()
  const onSubmit = useCallback(async (data) => {
    const command = {
      groupTypeId: groupTypeId,
      longName: data.longName,
      description: data.description
    }
    const result = await modifyClientTag(command)
    if (result.success) {
      setEditing(false)
    }
  }, [groupTypeId, modifyClientTag])
  const form = useForm({
    mode: 'onChange',
    defaultValues: {
      longName: tagDetailData?.longName || '',
      shortName: tagDetailData?.shortName || '',
      description: tagDetailData?.description || ''
    }
  })
  useEffect(() => {
    if (tagDetailData) {
      form.reset({
        longName: tagDetailData.longName || '',
        shortName: tagDetailData.shortName || '',
        description: tagDetailData.description || ''
      })
    }
  }, [tagDetailData, form])
  const toggleEditing = () => {
    setEditing(!editing)
  }
  const cancelEditing = () => {
    setEditing(false)
    form.reset()
  }
  if (detailsLoading) return <Loading />
  return (
    <div>
      <form className='flex flex-col gap-2' onSubmit={form.handleSubmit(onSubmit)}>
        <div className={classes.detailsHeader}>
          <h1>Tag Information</h1>
          <SydButton size='sm' icon='edit' onClick={toggleEditing}>Edit</SydButton>
          {isLoading && <Loading />}
        </div>
        <div className={classes.detailRow}>
          <div>
            <Controller
              control={form.control}
              name='longName'
              rules={{ required: true }}
              render={(f) => (
                <SydLabel label='Display Name' required error={hookFormErrorAdapter(form, f.fieldState)}>
                  <SydInput disabled={!editing} {...f.field} />
                </SydLabel>
              )}
            />

          </div>
          <div>
            <Controller
              control={form.control}
              rules={{ required: true }}
              name='shortName'
              render={(f) => (
                <SydLabel label='Code' required>
                  <SydInput disabled {...f.field} />
                </SydLabel>
              )}
            />
          </div>
        </div>
        <div className={classes.detailRow}>
          <div>
            <Controller
              control={form.control}
              name='description'
              render={(f) => (
                <SydLabel label='Description'>
                  <SydInput
                    disabled={!editing}
                    {...f.field}
                  />
                </SydLabel>
              )}
            />
          </div>
        </div>
        <div className={classes.detailRow}>
          <div className={classes.detailCol}>
            <h2>Member Type</h2>
            <div>
              <Chip color='primary' size='small' label={tagDetailData?.memberTypes?.[0].memberLevelTypeLongName} />
            </div>
          </div>
          <div className={classes.detailCol}>
            <h2>Selection Type</h2>
            <div>
              {tagDetailData.uniqueMembers === 0 ? (
                <Chip color='primary' size='small' label='Mulit-Select' />
              ) : (
                <Chip color='primary' size='small' label='Single-Select' />
              )}
            </div>
          </div>
        </div>
        {editing && <SaveCancelFooter onSave={form.handleSubmit(onSubmit)} onCancel={cancelEditing} />}
      </form>
    </div>
  )
}
TagDetailsTab.propTypes = {
  groupTypeId: PropTypes.number,
  tagDetailData: PropTypes.object,
  detailsLoading: PropTypes.bool
}
